import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { PayemtsApiResponse } from "./types/payments";
import toast from "react-hot-toast";
// Hook to manage payments data
export function usePayments() {
  const queryClient = useQueryClient();
  const toastId = "expense-toast";
   

  // GET all payments

  const Payments =(params:{ page?:number, size?: number ,fromDate?:string,toDate?:string ,propertyName?: string; }) => useQuery({
    queryKey: ["payments", params], // Adjust these values as needed
    queryFn: async ({ queryKey }) => {
      try {
        const response = await axios.get(`/api/v1/all_payments`, {
          params:queryKey[1], // Pass params directly here
        });
        //console.log("pay", response.data);
        return response.data  as PayemtsApiResponse;
      } catch (error) {
        console.error("Error fetching properties:", error);
        // throw error;
      }
    },
    
    staleTime: 30000,
    retry: false, // Disable retrying on failure

  });
  // const payments = useQuery({
  //   queryKey: ["payments"],
  //   queryFn: async () => {
  //     try {
  //       const response = await axios.get(`/api/v1/all_payments`);
  //       return response.data as PayemtsApiResponse;
  //     } catch (error) {
  //       console.error("Error fetching payments:", error);
  //       throw error;
  //     }
  //   },
  //   staleTime: 30000,
  // });


  // POST new payment
  const addPayment = useMutation({
    mutationFn: async (newPayment: any) => {
      try {
        const response = await axios.post(`/api/v1/save_payment_info`, newPayment);
        return response.data;
      } catch (error) {
        console.error("Error adding payment:", error);
        throw error;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey:["payments"]});
       toast.success("Payment has been successfully added.", { id: toastId });
    },
  });

  // GET payment by ID
  const getPaymentById = useMutation({
    mutationFn: async (id: string) => {
      try {
        const response = await axios.get(`/payments/${id}`);
        return response.data;
      } catch (error) {
        console.error("Error fetching payment by ID:", error);
        throw error;
      }
    },
  });

  // UPDATE payment
  const updatePayment = useMutation({
    mutationFn: async ({ id, updatedPayment }: { id: string; updatedPayment: any }) => {
      try {
        const response = await axios.put(`/api/v1/update_payment/${id}`, updatedPayment);
        return response.data;
      } catch (error) {
        console.error("Error updating payment:", error);
        throw error;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey:["payments"]});
        toast.success("Payment has been updated successfully", { id: toastId });
    },
  });

 

  interface PaymentApiParams {
    propertyId?: number;
    tenantId?: number;
    paymentStatus?: string;
    fromDate?: string;
    toDate?: string;
    rentOfFrom?: string;
    rentOfTo?: string;
    maxAmountReceived?: number;
    maxBalanceAmount?: number;
    paymentMode?: string;
    paymentType?: string;
    paymentCollectedById?: number;
    page?: number;
    size?: number;
  }
  
  const PaymentHistory = useMutation({
    mutationFn: async ({ filter, page, size }: { filter: Omit<PaymentApiParams, 'page' | 'size'>, page: number, size: number }) => {
      try {
        const params = new URLSearchParams();
        params.append('page', String(page));
        params.append('size', String(size));
  
        const response = await axios.post(`/api/v1/tenant-payment-history?${params.toString()}`, filter);
        //console.log("Payment History Response:", response.data);
        return response.data;
      } catch (error: any) {
        console.error("Error fetching payment history:", error);
        throw error;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["payments"] }); // Consider a more specific query invalidation
    },
  });
  

  

  // DELETE payment
  const deletePayment = useMutation({
    mutationFn: async (id: string) => {
      try {
        const response = await axios.delete(`/api/v1/permanent_delete_payment/${id}`);
        return response.data;
      } catch (error) {
        console.error("Error deleting payment:", error);
        throw error;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey:["payments"]});
        toast.success("Payment has been successfully deleted.", { id: toastId });
    },
  });

  return { queryClient,Payments,PaymentHistory, addPayment, getPaymentById, updatePayment, deletePayment };
}
